"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = require("./updateFavoritesUserOption");
var datapoints_1 = require("../datapoints");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Remove a favorite search to the favorite store
 */
exports.default = legacy_1.action('RemoveFavoriteSearch', datapoints_1.default.RemoveFavoriteSearch)(function removeFavoriteSearch(searchQuery, actionSource) {
    // Check if favoriteSearches doesn't contain the search query
    if (!owa_mail_favorites_store_1.favoritesStore.favoriteSearches.has(searchQuery)) {
        throw new Error('Cannot find the search query in favorite search list.');
    }
    // Remove favorite from the store
    owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.splice(owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.indexOf(searchQuery), 1);
    owa_mail_favorites_store_1.favoritesStore.favoriteSearches.delete(searchQuery);
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
});
//# sourceMappingURL=removeFavoriteSearch.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/removeFavoriteSearch.js
// module id = 4657
// module chunks = 14